import React from 'react';

export function americanExpress() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <defs>
        <rect id="amex-id" width="32" height="20" x="0" y="0" rx="2" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="amex-id__mask" fill="#fff">
          <use href="#amex-id" />
        </mask>
        <use fill="#286DB5" href="#amex-id" />
        <path fill="#FFF" d="M11 0h21v20H11z" mask="url(#amex-id__mask)" />
        <path
          fill="#286DB5"
          d="M10-1v22h22v-3.483h-2.912l-1.255-1.364-1.253 1.364h-8.573v-6.982h-2.823l3.549-8.044h3.366l.983 2.133V2.491h4.063l.909 2.28.91-2.28H32V-1H10zm19.63 4.597l-1.063 2.546-.513 1.26-.513-1.26-1.07-2.546H24.11v5.896h1.496V5.952l-.015-.864.345.864 1.453 3.54h1.325l1.454-3.54.343-.864-.015.864v3.54h1.496V3.598h-2.36zm-10.119 0l-2.605 5.896h1.702l.471-1.151h2.843l.47 1.15h1.717l-2.59-5.895h-2.008zm.63 2.127l.351-.902.354.902.564 1.371h-1.827l.558-1.371zm9.54 4.81l-1.812 1.93-1.803-1.93H24.11l2.786 2.95-2.786 2.925h1.913l1.811-1.929 1.804 1.93h1.959l-2.785-2.95 2.785-2.925H29.68zm-10.501 0v5.875h4.929v-1.252h-3.434V14.1h3.36v-1.247h-3.36V11.79h3.434v-1.255h-4.93zm11.161 2.911L32 15.157v-3.382l-1.659 1.67z"
          mask="url(#amex-id__mask)"
        />
      </g>
    </svg>
  );
}

export function applePay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <rect width="32" height="20" fill="#000" rx="2" />
        <rect width="30" height="18" x="1" y="1" fill="#FFF" rx="1" />
        <g fill="#000" fillRule="nonzero">
          <path d="M8.407 6.277c.27-.34.452-.799.404-1.266-.394.02-.875.263-1.154.604-.25.292-.471.77-.414 1.217.443.04.885-.224 1.164-.555m.399.643c-.643-.039-1.19.369-1.496.369-.307 0-.778-.35-1.286-.34a1.893 1.893 0 00-1.612.99c-.69 1.205-.182 2.991.49 3.973.326.485.719 1.02 1.237 1 .49-.02.681-.32 1.276-.32s.768.32 1.286.31c.537-.01.873-.485 1.2-.971.373-.553.527-1.088.536-1.117-.01-.01-1.036-.408-1.045-1.602-.01-1 .805-1.476.844-1.506-.46-.69-1.18-.767-1.43-.786M14.403 5.566c1.398 0 2.37.975 2.37 2.394 0 1.423-.992 2.403-2.404 2.403h-1.547v2.489h-1.119V5.567h2.7zm-1.58 3.849h1.28c.973 0 1.527-.53 1.527-1.45 0-.918-.554-1.443-1.522-1.443h-1.285v2.893zm4.243 1.927c0-.929.704-1.5 1.951-1.57l1.437-.086v-.409c0-.59-.394-.944-1.052-.944-.624 0-1.014.303-1.108.778h-1.018c.06-.96.868-1.666 2.165-1.666 1.273 0 2.086.681 2.086 1.747v3.66h-1.033v-.873h-.025c-.304.59-.968.964-1.656.964-1.028 0-1.747-.646-1.747-1.6zm3.388-.48v-.417l-1.292.08c-.644.046-1.008.334-1.008.788 0 .465.38.768.958.768.754 0 1.342-.526 1.342-1.217zm2.049 3.943v-.883c.08.02.259.02.349.02.499 0 .768-.211.933-.757 0-.01.095-.323.095-.328l-1.897-5.316h1.167l1.328 4.321h.02l1.327-4.321h1.138l-1.966 5.589c-.45 1.287-.968 1.701-2.056 1.701-.09 0-.36-.01-.44-.025z" />
        </g>
      </g>
    </svg>
  );
}

export function card() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <defs>
        <rect id="card-id" width="32" height="20" x="0" y="0" rx="2" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="card-id__mask" fill="#fff">
          <use href="#card-id" />
        </mask>
        <use fill="#D8E3E9" href="#card-id" />
        <path fill="#6E787D" d="M4 4h8v6H4z" mask="url(#card-id__mask)" />
        <rect
          width="13"
          height="2"
          x="4"
          y="14"
          fill="#6E787D"
          mask="url(#card-id__mask)"
          rx="1"
        />
        <rect
          width="6"
          height="2"
          x="19"
          y="14"
          fill="#6E787D"
          mask="url(#card-id__mask)"
          rx="1"
        />
      </g>
    </svg>
  );
}

export function diners() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <defs>
        <rect id="diners-id" width="32" height="20" x="0" y="0" rx="2" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="diners-id__mask" fill="#fff">
          <use href="#diners-id" />
        </mask>
        <use fill="#0079BE" href="#diners-id" />
        <g fillRule="nonzero" mask="url(#diners-id__mask)">
          <path fill="#0079BE" d="M0 0h32v20.096H0z" />
          <path
            fill="#FFF"
            d="M24.957 10.152c0-4.241-3.54-7.173-7.42-7.172H14.2c-3.925-.001-7.156 2.932-7.156 7.172 0 3.88 3.23 7.068 7.156 7.05h3.339c3.879.018 7.42-3.17 7.42-7.05z"
          />
          <path
            fill="#0079BE"
            d="M14.22 3.581c-3.587.001-6.494 2.915-6.495 6.51.001 3.595 2.908 6.508 6.495 6.51 3.588-.002 6.495-2.915 6.496-6.51-.001-3.595-2.908-6.509-6.496-6.51z"
          />
          <path
            fill="#FFF"
            d="M10.115 10.074a4.13 4.13 0 012.643-3.851v7.7a4.129 4.129 0 01-2.643-3.85zm5.59 3.851V6.223a4.132 4.132 0 012.644 3.85 4.131 4.131 0 01-2.645 3.852z"
          />
        </g>
      </g>
    </svg>
  );
}

export function discover() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <defs>
        <rect id="discover-id" width="32" height="20" x="0" y="0" rx="2" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="discover-id__mask" fill="#fff">
          <use href="#discover-id" />
        </mask>
        <use fill="#E8F0F4" href="#discover-id" />
        <path
          fill="#2A2E30"
          fillRule="nonzero"
          d="M13.422 6.494c.362 0 .666.074 1.036.252v.942c-.35-.325-.654-.462-1.056-.462-.79 0-1.412.622-1.412 1.41 0 .832.602 1.417 1.45 1.417.383 0 .681-.13 1.018-.45v.943c-.383.172-.694.24-1.056.24-1.284 0-2.28-.936-2.28-2.143 0-1.194 1.023-2.15 2.3-2.15zm-3.985.026c.474 0 .908.154 1.27.455l-.441.549c-.22-.234-.427-.333-.68-.333-.363 0-.627.197-.627.456 0 .221.148.339.654.517.958.333 1.243.628 1.243 1.28 0 .795-.615 1.349-1.49 1.349-.642 0-1.108-.24-1.496-.782l.544-.498c.194.356.518.547.92.547.376 0 .654-.246.654-.579a.487.487 0 00-.253-.425c-.084-.05-.252-.123-.582-.233-.791-.271-1.063-.56-1.063-1.126 0-.673.583-1.177 1.347-1.177zm9.63.071h.92L21.14 9.35l1.167-2.759h.913l-1.866 4.212H20.9l-1.833-4.212zm-16.301.007h1.237c1.366 0 2.319.844 2.319 2.056 0 .604-.291 1.188-.784 1.576-.415.327-.888.474-1.542.474h-1.23V6.598zm3.944 0h.842v4.106H6.71V6.598zm16.891 0h2.39v.695h-1.548v.912h1.491V8.9h-1.49v1.109h1.547v.695h-2.39V6.598zm2.948 0h1.25c.972 0 1.529.443 1.529 1.212 0 .629-.35 1.041-.984 1.164l1.36 1.73h-1.037l-1.166-1.65h-.11v1.65h-.842V6.598zm.842.646v1.244h.246c.538 0 .824-.222.824-.635 0-.4-.286-.609-.81-.609h-.26zm-23.783.05v2.715h.226c.544 0 .888-.1 1.153-.326.292-.247.467-.641.467-1.035 0-.394-.175-.776-.467-1.022-.278-.24-.609-.333-1.153-.333h-.226z"
          mask="url(#discover-id__mask)"
        />
        <path
          fill="#F47216"
          fillRule="nonzero"
          d="M17.03 6.467c1.176 0 2.13.945 2.13 2.114v.001c0 1.169-.954 2.116-2.13 2.116S14.9 9.75 14.9 8.582v-.001c0-1.169.954-2.114 2.13-2.114zm14.97 5.1c-1.07.735-9.062 5.895-22.915 8.433h22.914v-8.433z"
          mask="url(#discover-id__mask)"
        />
      </g>
    </svg>
  );
}

export function ebt() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <defs>
        <rect id="ebt-id" width="32" height="20" x="0" y="0" rx="2" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="ebt-id__mask" fill="#fff">
          <use href="#ebt-id" />
        </mask>
        <use fill="#D8E3E9" href="#ebt-id" />
        <path
          fill="#0C60A5"
          fillRule="nonzero"
          d="M10.6 15v-1.902H6.321v-2.3h3.505V8.91H6.321V6.9h4.121V5H4v10h6.6zm5.364 0c.55 0 1.063-.059 1.54-.176a3.921 3.921 0 001.253-.537c.357-.24.637-.545.84-.913.202-.368.303-.808.303-1.319 0-.337-.047-.636-.14-.897a2.171 2.171 0 00-.964-1.166 2.598 2.598 0 00-.716-.283v-.062c.207-.071.391-.184.552-.337.161-.154.298-.327.412-.522a2.571 2.571 0 00.358-1.303c0-.48-.096-.88-.288-1.197a2.18 2.18 0 00-.793-.767 3.525 3.525 0 00-1.182-.406A8.751 8.751 0 0015.669 5H12.2v10h3.764zm-.34-6.055H14.5V6.797h1.14c.564 0 .982.078 1.253.234.271.156.407.419.407.79 0 .34-.133.613-.399.818-.266.204-.692.306-1.278.306zm.278 4.372H14.6v-2.574h1.302c.638 0 1.114.094 1.427.283.314.189.471.503.471.942 0 .9-.633 1.349-1.898 1.349zM25.241 15V6.902H28V5h-7.8v1.902h2.76V15h2.28z"
          mask="url(#ebt-id__mask)"
        />
      </g>
    </svg>
  );
}

export function googlePay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <rect width="32" height="20" fill="#3C4043" rx="2" />
          <rect width="30" height="18" x="1" y="1" fill="#FFF" rx="1" />
        </g>
        <g fillRule="nonzero">
          <path
            d="M15.361 10.871v2.89h-.883V6.626h2.342a2.056 2.056 0 011.513.62c.8.774.85 2.077.099 2.913l-.099.103a2.077 2.077 0 01-1.513.609h-1.459zm0-3.369v2.492h1.48c.33.012.648-.125.873-.37.46-.494.45-1.291-.028-1.769a1.18 1.18 0 00-.844-.353h-1.48zm5.642 1.217c.653 0 1.169.183 1.547.541.378.359.565.86.565 1.491v3.01h-.845v-.677h-.037c-.367.558-.85.837-1.459.837-.515 0-.954-.16-1.3-.478a1.533 1.533 0 01-.52-1.195c0-.507.186-.905.554-1.207.367-.301.86-.45 1.475-.45.526 0 .954.103 1.294.297v-.21c0-.314-.132-.61-.362-.814a1.253 1.253 0 00-.85-.336c-.494 0-.883.216-1.168.649l-.78-.508c.417-.631 1.048-.95 1.887-.95zm-1.14 3.547c0 .239.11.46.29.597.198.16.44.245.686.24.373 0 .73-.154.993-.427.29-.285.438-.62.438-1.008-.274-.227-.658-.341-1.151-.335-.357 0-.658.09-.9.267-.235.176-.356.398-.356.666zm8.099-3.387l-2.95 7.028h-.91l1.096-2.459-1.935-4.569h.959l1.399 3.505h.016l1.365-3.505z"
            fill="#3C4043"
          />
          <path
            fill="#4285F4"
            d="M11.792 10.245c0-.279-.022-.558-.066-.83H8.003v1.575h2.133a1.9 1.9 0 01-.79 1.246v1.025h1.272c.746-.712 1.174-1.764 1.174-3.016z"
          />
          <path
            fill="#34A853"
            d="M8.003 14.25c1.064 0 1.963-.363 2.615-.99l-1.272-1.023c-.356.25-.811.393-1.343.393-1.031 0-1.903-.723-2.215-1.69h-1.31v1.058c.667 1.382 2.032 2.253 3.524 2.253z"
          />
          <path
            fill="#FBBC04"
            d="M5.788 10.939a2.552 2.552 0 010-1.57V8.316h-1.31a4.191 4.191 0 000 3.676l1.31-1.053z"
          />
          <path
            fill="#EA4335"
            d="M8.003 7.679a2.08 2.08 0 011.513.614l1.13-1.172a3.74 3.74 0 00-2.643-1.064c-1.493 0-2.857.876-3.526 2.259l1.31 1.058C6.1 8.401 6.973 7.68 8.004 7.68z"
          />
        </g>
      </g>
    </svg>
  );
}

export function mastercard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <rect width="32" height="20" fill="#314759" rx="2" />
          <circle cx="20" cy="10" r="7" fill="#F79E1B" />
          <circle cx="12" cy="10" r="7" fill="#EB001C" />
          <path
            fill="#FF5E01"
            d="M16.001 4.256A6.99 6.99 0 0119 10a6.99 6.99 0 01-2.999 5.744A6.984 6.984 0 0113 10a6.992 6.992 0 012.902-5.676l.1-.068z"
          />
        </g>
        <path
          fill="#F79E1B"
          fillRule="nonzero"
          d="M25.342 16.71v-.61h.222V16H25v.1h.22v.61h.122zm.47 0v-.233l-.013-.313.21.547h.088l.21-.548-.012.314v.234h.123V16h-.16l-.204.545-.205-.545h-.16v.71h.123z"
        />
      </g>
    </svg>
  );
}

export function meijerCreditCard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <rect width="32" height="20" fill="#D8E3E9" rx="2" />
        <path
          fill="#DB232D"
          d="M9 5.192h2.837v1.495C12.345 5.563 13.212 5 14.436 5c1.273 0 2.044.563 2.313 1.687C17.236 5.563 18.114 5 19.383 5c.708 0 1.274.128 1.693.384.42.257.711.608.877 1.053.164.445.247 1.283.247 2.515V16h-3V9.26c0-.805-.059-1.329-.175-1.57-.115-.243-.373-.365-.772-.365-.479 0-.791.16-.936.476-.145.318-.217.957-.217 1.918V16h-3V9.163c0-.77-.055-1.267-.164-1.495-.11-.228-.357-.343-.744-.343-.479 0-.797.167-.955.498-.158.33-.237.963-.237 1.896V16H9V5.192z"
        />
      </g>
    </svg>
  );
}

export function meijerMastercard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <rect width="32" height="20" fill="#D8E3E9" rx="2" />
        <path
          fill="#0C60A5"
          d="M10 5.157h2.364V6.38C12.788 5.46 13.51 5 14.53 5c1.06 0 1.703.46 1.927 1.38.406-.92 1.138-1.38 2.195-1.38.59 0 1.062.104 1.411.315.35.21.593.496.73.86.138.364.207 1.05.207 2.058V14h-2.5V8.485c0-.659-.049-1.087-.146-1.285-.096-.198-.31-.298-.643-.298-.4 0-.66.13-.78.39-.121.26-.18.782-.18 1.569V14H14.25V8.406c0-.63-.046-1.037-.137-1.223-.09-.187-.297-.28-.62-.28-.399 0-.664.136-.795.406-.132.271-.198.789-.198 1.552V14H10V5.157z"
        />
        <g transform="translate(22 13)">
          <circle cx="6.136" cy="2.864" r="2.864" fill="#F79E1B" />
          <circle cx="2.864" cy="2.864" r="2.864" fill="#EB001C" />
          <path
            fill="#FF5E01"
            d="M4.5.514a2.862 2.862 0 01.001 4.7 2.858 2.858 0 01-1.228-2.35A2.86 2.86 0 014.46.542L4.5.514z"
          />
          <path
            fill="#F79E1B"
            fillRule="nonzero"
            d="M8.423 6.03v-.612h.157v-.1h-.398v.1h.155v.611h.086zm.331 0v-.235l-.008-.313.147.547h.063l.148-.548-.009.314v.234h.087v-.71h-.113l-.144.544-.145-.545h-.113v.711h.087z"
          />
        </g>
      </g>
    </svg>
  );
}

export function visa() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="20"
      viewBox="0 0 32 20"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <rect width="32" height="20" fill="#1A1F70" rx="2" />
        <path
          fill="#FFF"
          d="M19.996 6c.694 0 1.27.123 1.74.269l.225.074-.368 1.64c-.942-.412-1.77-.383-2.072-.346-.607.076-.885.37-.891.649-.02.912 2.953 1.024 2.944 3.067C21.567 12.96 20.122 14 17.916 14c-.836-.009-1.644-.157-2.158-.34l-.179-.071.38-1.696.282.123a4.335 4.335 0 001.877.366c.604-.009 1.251-.238 1.257-.757.003-.311-.228-.541-.896-.87l-.194-.092c-.796-.37-1.853-.991-1.84-2.105C16.459 7.052 17.92 6 19.996 6zm-13.371.142c.455 0 .865.288.969.788l.885 4.478 2.186-5.266h2.207l-3.404 7.737H7.247L5.572 7.704c-.102-.38-.19-.52-.5-.68-.504-.26-1.338-.506-2.072-.658l.05-.224h3.575zm20.679 0L29 13.879h-1.944l-.252-1.156h-2.696l-.438 1.156h-2.206l3.152-7.17a.95.95 0 01.746-.557l.148-.01h1.794zm-11.43 0l-1.738 7.737h-2.1l1.737-7.737h2.1zm9.945 2.09l-1.106 2.905h1.742l-.636-2.905z"
        />
      </g>
    </svg>
  );
}
